var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90577 14.3481C4.70845 14.1507 4.59761 13.8831 4.59761 13.604C4.59761 13.3249 4.70845 13.0572 4.90577 12.8598L10.1157 7.6499L4.90577 2.43996C4.71405 2.24145 4.60796 1.97558 4.61036 1.69962C4.61275 1.42365 4.72345 1.15967 4.91859 0.964523C5.11373 0.769379 5.37772 0.658688 5.65368 0.65629C5.92965 0.653892 6.19552 0.759979 6.39402 0.951703L12.3481 6.90577C12.5454 7.10314 12.6563 7.37081 12.6563 7.6499C12.6563 7.92898 12.5454 8.19665 12.3481 8.39402L6.39402 14.3481C6.19665 14.5454 5.92898 14.6562 5.6499 14.6562C5.37081 14.6562 5.10314 14.5454 4.90577 14.3481Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.8ee7005fe3381de46f4a9cc1046634b7.svg";
export { ForwardRef as ReactComponent };